<template lang="pug">
.LessonSelectPage
  .content(ref="content")
    transition-group.inner(
      name="fade" :duration="500" tag="div"
      ref="inner"
    )
      .area(
        v-for="area,areaIndex in areas"
        v-show="areaIndex === currentAreaIndex"
        :style="{ backgroundImage: `url(${area.background.path})`}"
        :class="{ active: !areas[areaIndex-1] || areas[areaIndex-1].isFinished || areas[areaIndex].isActive }"
        :key="areaIndex"
      )
        .areaTitle {{area.title}}
        .stageMenu(
          v-for="stage, i in area.stages"
          :class="{ completed: stage.status === constants.PROGRESS_STATUS.COMPLETED, active: ((areaIndex === 0 || (areas[areaIndex-1] && areas[areaIndex-1].isFinished) ) && !area.stages[i-1]) || (area.stages[i-1] && area.stages[i-1].status === constants.PROGRESS_STATUS.COMPLETED) || stage.status === constants.PROGRESS_STATUS.COMPLETED }"
        )
          .button(
            @click="handleStageMenuClick(area.areaId,stage.stageId)"
            :data-tippy-content="`${ area.areaId }-${ stage.stageId} ${stage.title}`"
            v-menuHoverSound
            v-menuClickSound
          )
          .label {{ area.areaId }}-{{ stage.stageId }}
        .overlay(v-if="areas[areaIndex-1] && (!areas[areaIndex-1].isFinished && !areas[areaIndex].isActive)")

    .navigation
      .prevButton(
        v-show="currentAreaIndex !== 0"
        v-menuHoverSound
        v-menuClickSound
        @click="handlePrevButtonClick"
      )
      .nextButton(
        v-show="currentAreaIndex < areas.length - 1"
        v-menuHoverSound
        v-menuClickSound
        @click="handleNextButtonClick"
      )

    .positionIndicator
      .positionIndicatorItem(
        v-for="area,areaIndex in areas"
        v-menuClickSound
        :class="{ current: areaIndex === currentAreaIndex, active: !areas[areaIndex-1] || areas[areaIndex-1].isFinished || areas[areaIndex].isActive }"
        @click="handleIndicatorItemClick(areaIndex)"
      )

    .screenBlocker(v-if="isScreenLocked")
  km-loading-overlay(
    v-if="assetLoaded === false"
    :queuedAssets="assets"
    :loadedAssets="loadedAssets"
  )
  km-footer.footer(
    title="基本レッスン"
    subTitle=""
    :challengeResult="challengeResult"
    @onBackButtonClick=""
  )
</template>

<script>
import * as _ from 'lodash'
import tippy from 'tippy.js'
import { mapState, mapActions } from 'vuex'
import soundService from '@/services/SoundService'
import * as constants from '@/constants'

export default {
  name: 'lesson-select-page',
  components: {},
  data() {
    return {
      constants,
      assetLoaded: null,
      assets: [],
      isScreenLocked: false,
      currentAreaIndex: 0,
      areas: [
        // {
        //   id: 1,
        //   title: '体験版',
        //   menus: [
        //     {
        //       stageId: 1,
        //       status: null,
        //       title: '導入',
        //       description: ''
        //     }
        //   ]
        // }
      ],
      tippyInstances: null
    }
  },
  computed: {
    ...mapState('User', {
      rank: state => state.rank,
      lvl: state => state.lvl,
      exp: state => state.exp,
      progress: state => state.progress,
      point: state => state.point,
      account: state => state.account,
      challengeResult: state => state.challenge_result
    }),
    ...mapState('Assets', {
      loadedAssets: state => state.assets
    })
  },
  methods: {
    ...mapActions('Sound', ['playBGM', 'stopBGM']),
    ...mapActions('Assets', ['fetchAssets', 'isAssetLoaded']),
    async load() {
      try {
        this.assetLoaded = await this.isAssetLoaded('lessonSelect')

        const settings = await (
          await fetch('/app/static/json/settings.json', { cache: 'no-store' })
        ).json()
        this.areas = _.get(settings, 'basicLesson.areas', [])

        // レッスンの背景をプリロード対象に追加
        const lessonBackgroundAssets = _.map(this.areas, area => {
          return {
            type: 'image',
            path: area.background.path
          }
        })
        lessonBackgroundAssets.forEach(asset => {
          this.assets.push(asset)
        })

        await this.fetchAssets({
          currentPage: 'lessonSelect',
          assets: this.assets
        })
        setTimeout(() => {
          this.assetLoaded = true
        }, 500)
      } catch (e) {
        alert('読み込みエラー')
        this.$router.push('/')
      }
    },
    setProgress() {
      this.areas.map(area => {
        // ステージクリア状況の追加
        area.stages.forEach(stage => {
          const currentStageProgress = _.find(this.progress, { id: stage.id })
          if (currentStageProgress) stage.status = currentStageProgress.status
        })

        // エリアのクリア状況を追加
        // エリアの最終ステージをクリアしていればクリア判定で次エリアにアクセスできる
        // 過去に次エリアに行ってステージをクリアしている場合は次エリアもアクティブになる
        const lastStageId = area.stages[area.stages.length - 1].id
        const isAreaLastStageFinished =
          _.findIndex(this.progress, {
            id: lastStageId
          }) !== -1
        const isAnyAreaStageFinished = this.progress.some((progressItem) => progressItem.area === area.areaId)

        return Object.assign(area, {
          isFinished: isAreaLastStageFinished,
          isActive: isAnyAreaStageFinished
        })
      })
    },
    initTippy() {
      this.tippyInstances = tippy('.button', {
        followCursor: false
      })
    },
    resetTippy() {
      this.tippyInstances.forEach(instance => {
        instance.destroy()
      })
      setTimeout(() => {
        this.initTippy()
      }, 500)
    },
    changeArea() {
      // エリア移動
      this.isScreenLocked = true
      setTimeout(() => {
        const { type, areaId, stageId } = this.$route.query
        if (!areaId) {
          this.isScreenLocked = false
          return
        }
        // エリアの最終ステージクリア後にメニューに戻った場合は次のエリアに移動する
        const isAreaFinished =
          type === 'finished' &&
          stageId === this.areas[areaId - 1].stages.length &&
          this.areas[areaId] // 最終エリアから存在しないエリアへの移動を防ぐ
        this.currentAreaIndex = isAreaFinished ? areaId : areaId - 1
        this.isScreenLocked = false
      }, 1000)
    },
    handlePrevButtonClick() {
      this.currentAreaIndex--
      setTimeout(() => {
        this.resetTippy()
      })
    },
    handleNextButtonClick() {
      this.currentAreaIndex++
      setTimeout(() => {
        this.resetTippy()
      })
    },
    handleIndicatorItemClick(areaIndex) {
      this.currentAreaIndex = areaIndex
    },
    handleStageMenuClick(areaId, stageId) {
      soundService.play('lessonStageSelect')
      this.$router.push(`/lesson/player/${areaId}/${stageId}`)
    }
  },
  beforeMount() {
    // レッスンから戻った場合は同じエリアが表示されるようにする
    const { areaId } = this.$route.query
    if (areaId) this.currentAreaIndex = areaId - 1
  },
  async mounted() {
    this.playBGM('bgmMenu')
    await this.load()
    this.initTippy()
    this.setProgress()
    this.changeArea()
  },
  beforeDestroy() {
    this.tippyInstances.forEach(instance => {
      instance.destroy()
    })
  }
}
</script>

<style lang="scss" scoped>
.LessonSelectPage {
  width: 100%;
  height: 100%;
  background: #000;
}

.content {
  position: relative;
  width: 100%;
  height: calc(100% - 80px);
  overflow: hidden;

  .inner {
    display: flex;
    width: 100%;
    height: 100%;
  }
}

.navigation {
  .prevButton,
  .nextButton {
    position: absolute;
    top: calc(50% - 30px);
    width: 30px;
    height: 60px;
    background-size: cover;
    z-index: 100;
    transition: transform ease 0.3s;

    &:hover {
      opacity: 0.9;
      transform: scale(1.2);
    }

    &:active {
      opacity: 0.5;
      transform: scale(1);
    }
  }

  .prevButton {
    left: 30px;
    background-image: url('data:image/svg+xml;charset=utf8,%3Csvg%20version%3D%221.1%22%20id%3D%22%E3%83%AC%E3%82%A4%E3%83%A4%E3%83%BC_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2030%2060%22%20style%3D%22enable-background%3Anew%200%200%2030%2060%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%20.st0%7Bfill%3A%23FFFFFF%3B%7D%3C%2Fstyle%3E%3Cpath%20class%3D%22st0%22%20d%3D%22M30%2C60L0%2C30L30%2C0C30%2C59.5%2C30%2C60%2C30%2C60z%22%2F%3E%3C%2Fsvg%3E');
  }

  .nextButton {
    right: 30px;
    background-image: url('data:image/svg+xml;charset=utf8,%3Csvg%20version%3D%221.1%22%20id%3D%22%E3%83%AC%E3%82%A4%E3%83%A4%E3%83%BC_1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20x%3D%220px%22%20y%3D%220px%22%20viewBox%3D%220%200%2030%2060%22%20style%3D%22enable-background%3Anew%200%200%2030%2060%3B%22%20xml%3Aspace%3D%22preserve%22%3E%3Cstyle%20type%3D%22text%2Fcss%22%3E%20.st0%7Bfill%3A%23FFFFFF%3B%7D%3C%2Fstyle%3E%3Cpath%20class%3D%22st0%22%20d%3D%22M30%2C60L0%2C30L30%2C0C30%2C59.5%2C30%2C60%2C30%2C60z%22%2F%3E%3C%2Fsvg%3E');
    transform: rotate(180deg);

    &:hover {
      transform: rotate(180deg) scale(1.2);
    }

    &:active {
      transform: rotate(180deg) scale(1);
    }
  }
}

.area {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 100%;
  min-height: 100%;
  padding: 30px;
  flex-wrap: wrap;
  background: rgba(255, 255, 255, 0.8);
  background-size: cover;
  background-position: center center;
  pointer-events: none;

  &.active {
    pointer-events: auto;
  }

  .areaTitle {
    @include textBorder;
    position: absolute;
    left: 0;
    top: 100px;
    width: 100%;
    color: #fff;
    font-weight: bold;
    font-size: 3rem;
    text-align: center;
    z-index: 2;
  }

  .stageMenu {
    position: relative;
    margin: 0 40px 20px;
    text-align: center;
    z-index: 2;
    outline: none;
    opacity: 0.5;
    pointer-events: none;

    &.completed {
      .button {
        background-image: url(../assets/bg_selectButton_on.svg);
      }
    }

    &.active {
      opacity: 1;
      pointer-events: auto;
    }

    .label {
      @include textBorder;
      display: inline-block;
      // width: 60px;
      color: #fff;
      font-size: 2.5rem;
      text-align: center;
      border-radius: 20px;
    }

    .button {
      margin: 0 0 10px 0;
      width: 100px;
      height: 100px;
      background: url(../assets/bg_selectButton_off.svg) #fff;
      background-position: center;
      background-size: 90%;
      background-repeat: no-repeat;
      cursor: pointer;
      border-radius: 90px;
      outline: none;
      transition: 0.1s ease transform;
      transform: scale(1);
      &:hover {
        transform: scale(1.1);
      }
    }
  }

  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.95);
  }
}

.screenBlocker {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  opacity: 0;
}

.positionIndicator {
  position: absolute;
  display: flex;
  bottom: 30px;
  left: 30%;
  display: flex;
  margin: 0 auto;
  width: 40%;
  height: 30px;
  border: 3px solid #000;
  border-radius: 5px;
  overflow: hidden;
  z-index: 100;

  &::after {
    content: '';
    position: absolute;
    top: 6px;
    left: 0;
    border-bottom: 5px solid black;
    width: 100%;
    // z-index: 50;
  }
}

.positionIndicatorItem {
  flex: 1;
  position: relative;
  height: 100%;
  border-right: 1px solid #000;
  background: gray;
  transition: background ease 0.5s;
  z-index: 100;

  &:last-child {
    border-right: 0;
  }

  &.active {
    background: #fff;
  }

  &.current {
    background: yellow;
  }
}

.footer {
  position: absolute;
  bottom: 0;
}
</style>
